import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  setCanProceedToNextStep,
  setCustomTamplateNumberOfFasteners,
} from '../actions/generalActions.js'
import { withRoutingTracker } from '../HOC/withRoutingTracker.js'
import { getEstimate, scrollTo } from '../utils/utils.js'
import ReactSelect from 'react-select'
import DropdownIndicator from './Templates/DropdownIndicator'

class CustomTamplateFastenerSelector extends PureComponent {
  constructor(props) {
    super(props)

    const customFastenersOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    const selectOptions = customFastenersOptions.map((option) => {
      return { value: option, label: option }
    })
    this.state = {
      customFastenersOptions,
      selectOptions,
    }
  }

  componentDidMount() {
    const { customFastenersOptions } = this.state
    const { dispatch, general, params } = this.props
    const { enableScrollTo, noOfFasteners } = general

    if (!noOfFasteners) {
      if (enableScrollTo === true) {
        scrollTo('cushion-fastener-placement-selector')
      }
    }
    if (noOfFasteners) {
      dispatch(setCustomTamplateNumberOfFasteners(noOfFasteners))
      setTimeout(() => {
        dispatch(setCanProceedToNextStep(true))
      }, 100)
      setTimeout(() => {
        this._getPrice()
      }, 200)
    }

    if (
      customFastenersOptions.some(
        (option) => option.toString() === params.fasteners?.fastenersPlacement?.mirroredCheckboxes,
      )
    ) {
      let numberOfFasteners = params.fasteners?.fastenersPlacement?.mirroredCheckboxes
      dispatch(setCustomTamplateNumberOfFasteners(parseInt(numberOfFasteners)))
      setTimeout(() => {
        dispatch(setCanProceedToNextStep(true))
      }, 100)
      setTimeout(() => {
        this._getPrice()
      }, 200)
    }
  }

  _getPrice = () => {
    const { dispatch, general, params } = this.props
    setTimeout(() => {
      getEstimate(dispatch, general, params)()
    }, 100)
  }

  _setNumberOfFasteners = (e) => {
    const { dispatch } = this.props
    let number = e?.value

    if (number) {
      dispatch(setCustomTamplateNumberOfFasteners(number))
      dispatch(setCanProceedToNextStep(true))
    } else {
      dispatch(setCanProceedToNextStep(false))
      dispatch(setCustomTamplateNumberOfFasteners(null))
    }
    setTimeout(() => {
      this._getPrice()
    }, 200)
  }

  render() {
    const { selectOptions } = this.state
    const { general, hideDropdown } = this.props
    const { noOfFasteners } = general

    return (
      <div
        className={'cushion-fastener-placement-selector custom-fastener-placement-selector'}
        style={hideDropdown ? { minWidth: '140px' } : {}}
      >
        <div
          className="fasteners-dropdown-container"
          style={hideDropdown ? { display: 'none' } : {}}
        >
          <h4 className="custom-fastener-title">Select Number of Fasteners</h4>
          <ReactSelect
            value={selectOptions[noOfFasteners - 1 || 0]}
            defaultValue={selectOptions[noOfFasteners - 1 || 0]}
            className="fasteners-option-dropdown"
            onChange={this._setNumberOfFasteners}
            placeholder=""
            options={selectOptions}
            components={{
              DropdownIndicator,
              IndicatorSeparator: () => null,
            }}
          />
        </div>
        <div className="custom-template-fasteners-note">
          <p>
            Please mark on your template where fasteners should be placed for your custom cushion.
          </p>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  general: state.general,
})

export default connect(mapStateToProps)(withRoutingTracker(CustomTamplateFastenerSelector))
